import React, { useState, useEffect } from "react";

/**
 * pageKey - Name of page corresponding to the id,
 * height - height in px of the container
 * showLogo - true/false of whether to display a pb logo
 * logoSize - lg or sm logo
 * logoX - left x value of logo
 * logoY - top y value of logo
 */
const PAGE_PROPERTIES = {
  "628702e46d93f80021432761": {
    pageKey: "START_PAGE",
    height: 199,
    showLogo: true,
    logoSize: "sm",
    logoX: 106,
    logoY: 146,
  },
  "62870c6672fffa002f4a1c85": {
    pageKey: "INTRODUCTION",
    height: 236,
    showLogo: true,
    logoSize: "sm",
    logoX: 16,
    logoY: 24,
  },
  "62870cab8f8136001256167d": {
    pageKey: "ABOUT_YOU",
    height: 104,
    showLogo: true,
    logoSize: "sm",
    logoX: 16,
    logoY: 24,
  },
  "62870cd2bbd0f700231a62b0": {
    pageKey: "CONTACT_DETAILS",
    height: 104,
    showLogo: true,
    logoSize: "sm",
    logoX: 16,
    logoY: 24,
  },
  "62870ced0fdd5f00130c647c": {
    pageKey: "APLYID_VERIFICATION",
    height: 104,
    showLogo: true,
    logoSize: "sm",
    logoX: 16,
    logoY: 24,
  },
  "62870dfd0fdd5f0012534ef1": {
    pageKey: "PRODUCT",
    height: 104,
    showLogo: true,
    logoSize: "sm",
    logoX: 16,
    logoY: 24,
  },
  "62870de18f813600142a64b9": {
    pageKey: "CONFIRM_DETAILS",
    height: 104,
    showLogo: true,
    logoSize: "sm",
    logoX: 16,
    logoY: 24,
  },
  "62870e19bbd0f70033493ee2": {
    pageKey: "SUCCESS",
    height: 104,
    showLogo: true,
    logoSize: "sm",
    logoX: 16,
    logoY: 24,
  },
};

const LOGO_SRC_LG =
  "https://www.policebank.com.au/transformd-new/assets-shared/images/logo_pb_lg.svg";

const LOGO_SRC_SM =
  "https://www.policebank.com.au/transformd-new/assets-shared/images/logo_pb_sm.svg";

/**
 * Top Section Root Component.
 * Positioned ABOVE progress bar.
 * May or may not contain the PB logo.
 */
const LogoContainer = ({ getData }) => {
  const [currentPageId, setCurrentPageId] = useState(null);

  useEffect(() => {
    const emitter = getData().getEmitter();
    emitter.on("BeforePageRender", (data) => {
      if (data?.id) setCurrentPageId(data.id);
    });
  }, []);

  const properties = PAGE_PROPERTIES[currentPageId];
  const { height, showLogo, logoSize, logoX, logoY } = properties ?? {};

  const handleClick = () => {
    window.location.href = "www.policebank.com.au";
  };

  return <React.Fragment></React.Fragment>; // Logo disabled for now

  return !properties ? (
    <React.Fragment />
  ) : (
    <div
      className="custom__logo"
      style={{ width: "100%", height, position: "relative", cursor: "pointer" }}
      onClick={handleClick}
    >
      {showLogo && <Logo size={logoSize} x={logoX} y={logoY} />}
    </div>
  );
};

const Logo = ({ size = "sm", x = 0, y = 0 }) => {
  return <React.Fragment />; // Request for Logo to be disabled
  const src = size === "sm" ? LOGO_SRC_SM : size === "lg" ? LOGO_SRC_LG : "";
  const width = size === "sm" ? 144 : size === "lg" ? 216 : 0;
  const height = size === "sm" ? 32 : size === "lg" ? 48 : 0;

  return (
    <img
      src={src}
      style={{ width, height, position: "absolute", left: x, top: y }}
    />
  );
};

export default LogoContainer;
